// src/components/steps/CepInfoStep.js
import React, { useState } from "react";

const CepInfoStep = ({ setCep, cepValid, setCepValid, loading }) => {
  const [localCep, setLocalCep] = useState("");

  const formatCep = (v) => {
    let num = v.replace(/\D/g, "");
    if (num.length > 5) num = num.slice(0, 5) + "-" + num.slice(5, 8);
    return num;
  };

  const onChange = (e) => {
    const f = formatCep(e.target.value);
    setLocalCep(f);
    setCep(f);
    setCepValid(f.replace(/-/g, "").length === 8);

    // salva no localStorage com o hífen
    if (f) {
      localStorage.setItem("cep", f);
    } else {
      localStorage.removeItem("cep");
    }
  };

  return (
    <div>
      <label
        htmlFor="cep"
        className="block text-sm font-medium text-[#1F2937] mb-2"
      >
        CEP
      </label>
      <input
        id="cep"
        type="text"
        maxLength={9}
        value={localCep}
        onChange={onChange}
        placeholder="00000-000"
        className="w-full h-12 px-4 border border-[#D1D5DB] rounded-md bg-white text-[#6B7280] placeholder-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#2A4DD0]"
      />
      {loading && (
        <div className="flex justify-center mt-4">
          <div className="w-6 h-6 border-4 border-[#E5E7EB] border-t-[#2A4DD0] rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  );
};

export default CepInfoStep;
